import React, { useState, useEffect } from 'react';
import './InitiatePaymentIframe.css';
import { Link, useNavigate,  useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { showToast } from '../toastUtils';
import FullscreenLoader from '../FullscreenLoader';
//for sorting icon implementation
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { queuedApiFetch, apiFetch } from '../api';

const MySwal = withReactContent(Swal);

function PaymentClaims() {    

    var submitLoading = false;
    
    const [originalRows, setOriginalRows] = useState([]);
    const [rows, setRows] = useState([]);
  
    const [loading, setLoading] = useState(true); // New loading state
    
    const [searchQuery, setSearchQuery] = useState('');
    
    const accountId = localStorage.getItem('accountId');
 
    const getProjectDetails = localStorage.getItem('projectDetails');
    const selectedProjectDetail = JSON.parse(getProjectDetails);
    const projectNum = selectedProjectDetail.projectNumber;
    const getUserDetails = localStorage.getItem('userDetails');
    const userDetails = getUserDetails ? JSON.parse(getUserDetails): '';
    const userId = userDetails ? userDetails.id : '';
    const getUserAccess = userDetails ? userDetails.access_level : '';
    var payment_data = false;
    const getUserEmail = localStorage.getItem('userEmail');
    const [userCompany, setUserCompany] = useState();
    const [userPermission, setUserPermission] = useState();
    const getUserCompanyDetails =userCompany;
    

    let parametervalue;
    // console.log('user Company Name', getUserCompanyDetails);

    //Parameter passing
    if(getUserCompanyDetails==="NUS"){
      parametervalue=1;
    }else{
      parametervalue=0;
    }

  let p_access = selectedProjectDetail.Proj_Access.proj_access_level;
  let p_roles = selectedProjectDetail.Proj_Access.proj_role.join(", ");
  let proj_name=selectedProjectDetail?.projectName;

  let qs_params = `nususer=${parametervalue}&project_admin=${(p_access) ? 1 : 0}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;

    const fetchUserCompany = async () => {
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
      };
       try {
        const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
        const data = await response;
    
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          setUserCompany(data.data.company_name);
          setUserPermission(data.data.access_level);     
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); 
      }
    }

    useEffect(() => {
      const fetchData = async () => {
        await fetchUserCompany();
      };
      fetchData();
    }, []);
    

    const navigate = useNavigate();
    
    const openPopup = (span,row) => {
    Swal.fire({
      input: 'textarea',
      inputPlaceholder: 'Enter Remarks',
      title: 'Reject Payment Claim',
      showCancelButton: true,
      confirmButtonText: 'Confirm reject and notify user.',
      cancelButtonText: 'Cancel',
      showCloseButton: true,
      customClass: {
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const remarks=result.value;
       span.parentElement.parentElement.innerHTML = '<span style="color:red;">Rejected</span>';
       UpdateClaimStatus(row.id,'Rejected',remarks);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        
      }
    });
  };
    
    const claim_status_clicked = async (span,row,approve) => {
        if (approve)
        {
            window.open(`https://acc.autodesk.com/cost/cost/projects/${row.project_id}/cost-payments/list?${qs_params}`);
            span.parentElement.parentElement.innerText = 'Submitted';
            UpdateClaimStatus(row.id,'Submitted','');
        }
        else
        {
            openPopup(span,row);
        }
        //alert('ID=' + row.id + '          ' + td.innerHTML);
     }
    // console.log('SC Number',scNumber);
    const getPaymentClaims = async () => {
      setLoading(true); // Start loading
    
    if (payment_data)
         return;
     
     payment_data = true;
     
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
      };
    
      try {
        const response = await queuedApiFetch(`/payment/payment_claims?project_id=${projectNum}`, requestOptions);
        const data = await response;
        
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
                 
          setOriginalRows(data.data);
          setRows(data.data);
          console.log('ZZZ',rows);
        
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); // End loading
      }
    };

useEffect(() => {
    getPaymentClaims();
  }, []);
    
   const UpdateClaimStatus = async (id,claim_status,remarks) => {
          
    if (submitLoading) return; // Prevent multiple submissions if already loading
  
    submitLoading = true;
  
    try {
      const sendData = {
        id:id,          
        claim_status: claim_status ,
        remarks: remarks 
      };
  
      const requestOptions = {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        //   'ngrok-skip-browser-warning': '69420',
        // },
        body: JSON.stringify(sendData),
      };
  
      const response = await queuedApiFetch(`/payment/updateclaimstatus`,
        requestOptions
      );
      const result = await response;
  
      if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
        showToast.success('Data saved successfully');
      } else {
        showToast.error(result.apistatus.Status_Description || 'Error occurred. Please try again later');
      }
    } catch (error) {
      console.error('Error saving data:', error);
      showToast.error('An error occurred while saving data.');
    } finally {
      submitLoading = false;
    }
  };

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        
        setSearchQuery(query);
        if (query === '') {
          // If the search query is empty, refetch data
          getPaymentClaims(); // Re-fetch data from the API
        } else {
          // console.log(originalRows);
          // Filter rows based on search query
          const filteredData = originalRows.filter((row) =>
            row.User_name.toLowerCase().includes(query) || 
            row.Company.toLowerCase().includes(query) ||
            row.claim_amount.includes(query) ||
            row.work_done_until.includes(query) ||  
            row.total_claims.toString().includes(query) ||     
            row.claim_no.toString().includes(query) ||                  
            row.claim_status.toLowerCase().includes(query)
          );          
          setRows(filteredData);
        }
      };

      const location = useLocation();
      useEffect(() => {
        // If the URL path is `/` (root), redirect to `/homeacc`
        if (location.pathname === '/') {
          navigate('/homeacc');
        }
      }, [location, navigate]);

 
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    const sortRows = (rows, config) => {
      const sortedRows = [...rows];
      if (config.key) {
          sortedRows.sort((a, b) => {
              let aValue = a[config.key];
              let bValue = b[config.key];
  
         
                  // For other fields (e.g., Proj_Name), perform normal string comparison
                  if (typeof aValue === 'string') {
                      aValue = aValue.toLowerCase();
                  }
                  if (typeof bValue === 'string') {
                      bValue = bValue.toLowerCase();
                  }
              
  
              // Compare the values and sort in the specified direction
              if (aValue < bValue) return config.direction === 'asc' ? -1 : 1;
              if (aValue > bValue) return config.direction === 'asc' ? 1 : -1;
              return 0;
          });
      }
      return sortedRows;
  };
   
    
    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };
    
    const sortedRows = sortRows(rows, sortConfig);
    // const filteredRows = selectedProject
    //     ? rows.filter(row => row.Proj_Name === selectedProject)
    //     : rows;        

    return (
        <div className="bodywrap">
          {loading && <FullscreenLoader />} 
            <div className="header">
             
                <input type="text" id="searchBox" placeholder="Search" value={searchQuery} onChange={handleSearch} />
            </div>

            <div className="tablewrap" style={{width : '95%', height: 'auto', marginBottom: 120}}>
           <table id="claimTable">
                <thead>
                    <tr>
                        <th>Sno.</th>
                        <th onClick={() => handleSort('User_name')}>
                            Submitted by&nbsp;&nbsp;
                            <FontAwesomeIcon icon={sortConfig.key === 'User_name' ? (sortConfig.direction === 'asc' ? faSortUp : faSortDown) : faSort} />
                        </th>
                        <th onClick={() => handleSort('Company')}>
                            Vendor Name&nbsp;&nbsp;
                            <FontAwesomeIcon icon={sortConfig.key === 'Company' ? (sortConfig.direction === 'asc' ? faSortUp : faSortDown) : faSort} />
                        </th>
                         <th onClick={() => handleSort('claim_amount')}>
                            Claim Amount&nbsp;&nbsp;
                            <FontAwesomeIcon icon={sortConfig.key === 'claim_amount' ? (sortConfig.direction === 'asc' ? faSortUp : faSortDown) : faSort} />
                        </th>
                         <th onClick={() => handleSort('work_done_until')}>
                            Work Done Until&nbsp;&nbsp;
                            <FontAwesomeIcon icon={sortConfig.key === 'work_done_until' ? (sortConfig.direction === 'asc' ? faSortUp : faSortDown) : faSort} />
                        </th>
                        <th>Total Claimed Sum</th>
                        <th onClick={() => handleSort('claim_no')}>
                            Claim No&nbsp;&nbsp;
                            <FontAwesomeIcon icon={sortConfig.key === 'claim_no' ? (sortConfig.direction === 'asc' ? faSortUp : faSortDown) : faSort} />
                        </th>
                        <th onClick={() => handleSort('claim_status')}>
                            Claim Status&nbsp;&nbsp;
                            <FontAwesomeIcon icon={sortConfig.key === 'claim_status' ? (sortConfig.direction === 'asc' ? faSortUp : faSortDown) : faSort} />
                        </th>                       
                    </tr>
                </thead>
                <tbody>
                    {sortedRows.length === 0 ? (
                        <tr>
                            <td colSpan="8" style={{ textAlign: 'center', height: '100px', verticalAlign: 'middle', padding: '20px' }}>
                                {loading ? 'Loading...' : 'No records found'}
                            </td>
                        </tr>
                    ) : (
                        sortedRows.map((row, index) => (
                            <tr key={index + 1}>
                                <td className="undescription-column">{index + 1}</td>
                                <td className="total-column">{row.User_name}</td>
                                <td className="total-column">{row.Company}</td>
                                <td className="total-column">{row.claim_amount}</td>
                                <td className="total-column">{row.work_done_until}</td>   
                                <td className="total-column">{row.total_claims}</td>
                                <td className="total-column">{row.claim_no}</td>
                                    {row.claim_status === 'New' ? (
                                <td className="total-column"><span onClick={(e) => claim_status_clicked(e.target,row,true)} style={{cursor: 'pointer',color:'black'}}><u>Submit for Payment Approval</u></span><br/><span onClick={(e) => claim_status_clicked(e.target,row,false)} style={{cursor: 'pointer',color:'red'}}><u>Reject</u></span></td>      
                                    ):(
                                    // <td className="total-column">{row.claim_status}</td>
                                <td className="total-column">
                                    {row.claim_status === "Submitted" ? (
                                      <a
                                        href={`https://acc.autodesk.com/cost/cost/projects/${projectNum}/cost-payments/list?${qs_params}&menu=Construction_Progress claims_Initiate Payment`}
                                        // target="_blank"
                                        style={{ color: 'blue', textDecoration: 'underline' }}
                                      >
                                        {row.claim_status}
                                      </a>
                                    ) : (
                                      row.claim_status
                                    )}
                                </td>                                  
                            )}           
                            </tr>
                        ))
                    )}
                </tbody>
            </table> 
            </div>
        </div>
    );
}

export default PaymentClaims;
